import {
  BusinessProfileOption,
  CompanyCreationModes,
  CompanyCreationSteps,
  FranchiseOption,
} from '../../../../../views/companies';
import { BusinessType } from '../../../../../services/exports/Constants';

export default {
  title: 'Uusi ravintola',
  sections: {
    new_company: {
      titles: {
        [CompanyCreationModes.demo]: 'Uusi demo',
        [CompanyCreationModes.full]: 'Uusi ravintola',
      },
      steps: {
        [CompanyCreationSteps.CompanyInfo]: 'Ravintolan tiedot',
        [CompanyCreationSteps.BusinessInfo]: 'Yritystiedot',
        [CompanyCreationSteps.AdditionalLocations]: 'Lisäravintolat',
      },
    },
    business_profile: {
      legal_info: 'Lakitiedot',
      owner_info: 'Omistajan tiedot',
    },
    recently_created: 'Äskettäin luodut',
  },
  form: {
    franchise: {
      label: 'Luo ravintola',
      tooltip:
        'Valitse, luotko täysin uuden brändin vai lisäätkö tämän ravintolan olemassa olevaan brändiin järjestelmässämme.',
      options: {
        [FranchiseOption.CreateFranchise]: {
          title: 'Luo uusi brändi',
          tooltip: 'Aloitamme alusta — ei olemassa olevaa brändiä tai ravintolaa',
        },
        [FranchiseOption.UseExistingFranchise]: {
          title: 'Lisää tämä ravintola olemassa olevaan brändiin',
          tooltip: 'Se kuuluu brändiin, joka on jo järjestelmässä',
        },
      },
    },
    restaurants: {
      label: 'Liittyvät ravintolat',
    },

    business_profile: {
      label: 'Kuka on omistaja?',
      tooltip:
        'Kuuluuko tämä ravintola omistajalle/yritykselle, joka on jo järjestelmässämme (esim. ”Luís Pizza GmbH”)? <br/> Jos kyllä, valitse olemassa oleva omistaja-/yritysprofiili. Muussa tapauksessa luo uusi omistaja-/yritysprofiili.',
      options: {
        [BusinessProfileOption.CreateBusinessProfile]: 'Luo uusi omistaja-/yritysprofiili',
        [BusinessProfileOption.UseExistingBusinessProfile]: 'Käytä olemassa olevaa omistaja-/yritysprofiilia',
      },
    },
    business_type: {
      label: 'Yritystyyppi',
      placeholder: 'Valitse yritystyyppi',
      options: {
        [BusinessType.Company]: 'Yritys',
        [BusinessType.Individual]: 'Toiminimi',
      },
    },
    display_name: {
      label: 'Ravintolan nimi',
      placeholder: 'Näyttönimi',
    },
    legal_name: {
      label: 'Virallinen nimi',
      placeholder: 'Virallinen nimi',
    },
    owner_first_name: {
      label: 'Yhteyshenkilön etunimi',
      placeholder: 'James',
    },
    owner_last_name: {
      label: 'Yhteyshenkilön sukunimi',
      placeholder: 'Bond',
    },
    owner_phone_number: {
      label: 'Yhteyshenkilön puhelinnumero',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'Yhteyshenkilön sähköposti',
      placeholder: 'Anna sähköposti',
    },
    password: {
      label: 'Salasana',
      placeholder: 'Anna salasana',
    },

    additional_companies: {
      label: 'Lisäravintolat tämän brändin alla',
      tooltip:
        'Onko samalla brändillä kuin {{company}} muita ravintoloita? <br/> Jos kyllä, napsauta ”Lisää ravintola” lisätäksesi lisää toimipaikkoja tämän brändin alle. Jos kyseessä on sama omistaja mutta eri brändi, älä lisää sitä tähän. Luo se sen sijaan erikseen.',
    },
  },
  labels: {
    create_demo: 'Luo demo',
    create_company: 'Luo ravintola',
    business_type: 'Yritystyyppi',
    display_name: 'Näyttönimi',
    legal_name: 'Virallinen nimi',
    owner_name: 'Omistajan nimi',
    address: 'Osoite',
  },
  fields: {
    name: 'Nimi',
    created_at: 'Luotu',
    actions: 'Toiminnot',
  },

  buttons: {
    add_restaurant: '+ Lisää ravintola',
    continue: 'Jatka',
    back: 'Takaisin',
    create: 'Luo ravintola',
    delete: 'Poista',
  },
  popups: {
    delete_demo: {
      title: 'Haluatko varmasti poistaa?',
    },
  },
  toasts: {
    company_created: 'Ravintola luotu onnistuneesti',
    failed_to_create_company: 'Ravintolan luominen epäonnistui',
    failed_to_delete_demo: 'Demon poistaminen epäonnistui',
    demo_got_deleted: 'Demo poistettu onnistuneesti',
    failed_to_load_recently_created_companies: 'Äskettäin luotujen ravintoloiden lataaminen epäonnistui',
  },
};
